/* eslint-disable no-restricted-globals */
import { Checkbox, PrimaryButton, Stack, TextField } from "@fluentui/react";
import * as React from "react";
import logo from "./img/urmaker-bjerke_signatur_hvit_rgb.png";
import { ReactComponent as Footer } from "./img/footer.svg";
import { initializeIcons } from "@fluentui/react/lib/Icons";
import { useEffect, useState } from "react";
import { Link } from "office-ui-fabric-react";
import "./Loading.css";
interface ISamtykkeskjemaProps {}

initializeIcons();

const stackTokens = { childrenGap: 10 };

const urlParams = new URLSearchParams(window.location.search);
const id = urlParams.get("id");

export const Samtykkeskjema: React.FunctionComponent<ISamtykkeskjemaProps> = (
  props: ISamtykkeskjemaProps
) => {
  const [kundenummer, setKundenummer] = useState("");
  const [navn, setNavn] = useState("");
  // const [fornavn, setFornavn] = useState("");
  // const [etternavn, setEtternavn] = useState("");
  const [epost, setEpost] = useState("");
  const [mobiltelefon, setMobiltelefon] = useState("");
  const [samtykkeLagring, setSamtykkeLagring] = useState(false);
  const [samtykkeMarked, setSamtykkeMarked] = useState(false);

  const [isPosted, setIsPosted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    // fetch()
    const url = "https://urmb.no/api/getCustNo";
    const options = {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json;charset=UTF-8",
      },
      body: JSON.stringify({
        urlId: id,
      }),
    };

    fetch(url, options)
      .then((response) => response.json())
      .then((data) => {
        if (data !== "Not found") {
          setKundenummer(data);
        }
      });
  }, []);

  useEffect(() => {
    if (kundenummer) {
      // fetch()
      const url = "https://urmb.no/api/getCustData";
      const options = {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json;charset=UTF-8",
        },
        body: JSON.stringify({
          Kundenummer: kundenummer,
        }),
      };

      fetch(url, options)
        .then((response) => response.json())
        .then((data) => {
          setNavn(data.Navn);
          // setFornavn(data.Fornavn);
          // setEtternavn(data.Etternavn);
          setEpost(data.Epost);
          setMobiltelefon(data.Mobiltelefon);
          setSamtykkeLagring(data.SamtykkeLagring);
          setSamtykkeMarked(data.SamtykkeMarked);
        });
    }
  }, [kundenummer]);

  return (
    <>
      {/* {true && ( */}
      {isLoading && (
        <div className="loading">
          <p
            style={{
              color: "black",
              position: "relative",
              top: "120px",
              fontSize: "20px",
              width: "150px",
              left: "-35px",
            }}
          >
            Lagrer samtykke...
          </p>
        </div>
      )}
      <div style={{ margin: 20 }}>
        {/* {true && ( */}
        {kundenummer && !isPosted && (
          <Stack tokens={stackTokens}>
            <div id="logo" style={{ backgroundColor: "black", padding: 10 }}>
              <img src={logo} alt="" height="40" />
            </div>
            <div style={{ textAlign: "center", fontSize: 16 }}>
              Samtykke for lagring av kundeopplysninger
            </div>
            <TextField label="Kundenummer" value={kundenummer} readOnly />
            <TextField
              name="navn"
              label="Navn *"
              value={navn}
              onChange={(
                event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
                newValue?: string | undefined
              ) => {
                setNavn(newValue ? newValue : "");
              }}
            />
            {/* <TextField
              name="fornavn"
              label="Fornavn"
              value={fornavn}
              onChange={(
                event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
                newValue?: string | undefined
              ) => {
                setFornavn(newValue ? newValue : "");
              }}
            />
            <TextField
              name="etternavn"
              label="Etternavn"
              value={etternavn}
              onChange={(
                event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
                newValue?: string | undefined
              ) => {
                setEtternavn(newValue ? newValue : "");
              }}
            /> */}
            <TextField
              name="epost"
              label="E-post"
              value={epost}
              onChange={(
                event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
                newValue?: string | undefined
              ) => {
                setEpost(newValue ? newValue : "");
              }}
            />
            <TextField
              name="mobiltelefon"
              label="Mobiltelefon *"
              value={mobiltelefon}
              onChange={(
                event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
                newValue?: string | undefined
              ) => {
                setMobiltelefon(newValue ? newValue : "");
              }}
            />
            <div></div>
            <div>
              <Link
                style={{ color: "#2F655E" }}
                href="https://www.urmaker-bjerke.no/personvernserklaering/"
                underline
              >
                Personvernerklæring
              </Link>
            </div>
            <div></div>
            <Checkbox
              label="Samtykke for lagring av data"
              checked={samtykkeLagring}
              onChange={(
                ev?:
                  | React.FormEvent<HTMLElement | HTMLInputElement>
                  | undefined,
                checked?: boolean | undefined
              ) => {
                setSamtykkeLagring(checked ? checked : false);
                if (!checked) {
                  setSamtykkeMarked(false);
                }
              }}
            />
            <Checkbox
              label="Samtykke for bruk av data til markedsføring"
              checked={samtykkeMarked}
              disabled={!samtykkeLagring}
              onChange={(
                ev?:
                  | React.FormEvent<HTMLElement | HTMLInputElement>
                  | undefined,
                checked?: boolean | undefined
              ) => {
                setSamtykkeMarked(checked ? checked : false);
              }}
            />
            <div></div>
            <div></div>
            <PrimaryButton
              text="Send inn"
              disabled={!navn || !mobiltelefon}
              style={{
                backgroundColor: "#2F655E",
                border: "1px solid #2F655E",
                minHeight: 50,
              }}
              onClick={() => {
                setIsLoading(true);

                // Call api for å oppdatere data og vis melding

                // fetch()
                const url = "https://urmb.no/api/postCustData";
                const options = {
                  method: "POST",
                  headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json;charset=UTF-8",
                  },
                  body: JSON.stringify({
                    Kundenummer: kundenummer,
                    Navn: navn,
                    Mobiltelefon: mobiltelefon,
                    Epost: epost,
                    SamtykkeLagring: samtykkeLagring,
                    SamtykkeMarked: samtykkeMarked,
                  }),
                };

                fetch(url, options)
                  .then((response) => response.json())
                  .then((data) => {
                    setIsLoading(false);
                    setIsPosted(true);
                  });
              }}
            />
            <div></div>
            <div></div>
            <Footer />
          </Stack>
        )}
      </div>
      <div style={{ margin: 20 }}>
        {isPosted && (
          <Stack tokens={stackTokens}>
            <div id="logo" style={{ backgroundColor: "black", padding: 10 }}>
              <img src={logo} alt="" height="40" />
            </div>
            <div></div>
            <div></div>
            <div style={{ fontSize: 20 }}>
              <div>Takk for ditt svar!</div>
              <div></div>
              <div></div>
              <div style={{ fontSize: 16, marginTop: 30, marginBottom: 30 }}>
                <div>Med vennlig hilsen</div>
                <div>Urmaker Bjerke As</div>
              </div>
            </div>
            <div></div>
            <Footer />
          </Stack>
        )}
      </div>
    </>
  );
};
